<template>
  <Modal
    ref="selectCargoTemplateModalRef"
    @onNegativeActionClick="navigateCreateNewTemplate"
    @onPositiveActionClick="updateShipmentTemplate"
    :isPositiveActionPending="isSelectedShipmentTemplateLoading"
    :isPositiveActionButtonDisabled="isSelectedShipmentTemplateLoading"
    negativeActionText="Yeni Şablon Oluştur"
    positiveActionText="Kaydet"
    :showIcon="false"
    class="selectCargoTemplateModal"
  >
    <template v-slot:body>
      <h2 class="selectCargoTemplateModal-title">Kargo Şablonu Seç</h2>
      <p class="selectCargoTemplateModal-topText">
        Siparişleriniz için mevcut kargo şablonlarınızdan birini seçebilir ya da
        yeni kargo şablonu oluşturabilirsiniz.
      </p>
      <RadioButtonGroup
        name="selectCargoTemplateModal-radioGroup"
        class="selectCargoTemplateModal-radioGroup"
        :options="shipmentTemplatesTransform()"
        @select="selectedShipmentTemplate = $event"
      />
    </template>
  </Modal>
</template>

<script setup>
import { ref } from "vue";
import { useStore } from "vuex";
import { Modal, RadioButtonGroup } from "@n11/so-ui-components";
import { sendAddShipmentTemplateEvent } from "@/utils/ga4/helper";
import { ToastMessageTypes } from "@/utils/enum/toastMessageTypes";

const props = defineProps({
  shipmentTemplates: {
    type: Array,
    required: false,
    default: [],
  },
  getSelectedRows: {
    type: Array,
    required: false,
    default: [],
  },
});

const emit = defineEmits(["successUpdateCargoTemplate"]);

const store = useStore();

const selectCargoTemplateModalRef = ref();
const selectedShipmentTemplate = ref();
const isSelectedShipmentTemplateLoading = ref(false);

const shipmentTemplatesTransform = () => {
  return props.shipmentTemplates.map((item) => ({
    id: item.id,
    name: item.templateName,
  }));
};

const openSelectCargoTemplateModal = () =>
  selectCargoTemplateModalRef?.value?.openModal();

const closeSelectCargoTemplateModal = () =>
  selectCargoTemplateModalRef.value.hiddenModal();

const navigateCreateNewTemplate = () => {
  closeSelectCargoTemplateModal();
  window.open("/selleroffice/product/createShipmentTemplate", "_blank");
};

const updateShipmentTemplate = async () => {
  const pids = Object.keys(props.getSelectedRows);
  isSelectedShipmentTemplateLoading.value = true;

  try {
    await store.dispatch("templates/updateShipmentTemplate", {
      pids,
      shipmentId: selectedShipmentTemplate.value.id,
    });

    emit("successUpdateCargoTemplate");

    store.commit("common/SET_TOASTER_DATA", {
      type: ToastMessageTypes.SUCCESS,
      title: ToastMessageTypes.SUCCESS_TITLE,
      description: ToastMessageTypes.SUCCESS_CARGO_DESCRIPTION,
    });

    sendAddShipmentTemplateEvent({
      template: selectedShipmentTemplate.value.name,
    });
  } catch (error) {
    console.error(error);
    store.commit("common/SET_TOASTER_DATA", {
      type: ToastMessageTypes.ERROR,
      title: ToastMessageTypes.ERROR_TITLE,
      description: ToastMessageTypes.ERROR_CARGO_DESCRIPTION,
    });
  } finally {
    isSelectedShipmentTemplateLoading.value = false;
    closeSelectCargoTemplateModal();
  }
};

defineExpose({
  openSelectCargoTemplateModal,
});
</script>

<style lang="scss" scoped>
.selectCargoTemplateModal {
  &-title {
    font-size: 20px;
    font-weight: 700;
    text-align: left;
    margin-bottom: 12px;
  }

  &-topText {
    text-align: left;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 12px;
  }

  &-radioGroup {
    margin-bottom: 12px;
    gap: 16px;
  }
}
</style>
